import { PlanComponent } from "@labs/shared/types/AnalyzedPlan";
import { EmissionsBySource } from "@labs/shared/types/EmissionsBySource";
import { FuelSource } from "@labs/shared/types/FuelSource.ts";

export const getFootprintAfterPlan = (
  baselineCarbonWithGrowthAndCleanerGrid: EmissionsBySource,
  planComponents: PlanComponent[],
): EmissionsBySource => {
  const starter: Record<string, number> = {
    ...baselineCarbonWithGrowthAndCleanerGrid,
  };

  return planComponents.reduce((acc, component) => {
    component.fuelImpacts.forEach(({ fuelSource, carbonImpact }) => {
      // skip carbon, since we just want to capture our emissions sources from other fuels
      // to compare to baseline
      if (fuelSource !== FuelSource.Carbon) {
        acc[fuelSource] = (acc[fuelSource] || 0) + carbonImpact;
      }
    });
    return acc;
  }, starter) as EmissionsBySource;
};
